import { UuidV4 as BaseUuidV4 }		from "ts-base/textual/uuidV4";

import { Textual }	from "@v3/data/textual";

export type UuidV4		= Textual.Value<typeof UuidV4>;
export const UuidV4		= Textual.fromBase(BaseUuidV4, "must be an uuid v4");
